(function () {
  'use strict';

  function initSlider(sectionId) {
    var track = document.getElementById('bsl-track-' + sectionId);
    if (!track) return;

    var prevBtn = document.querySelector('.bsl-arr--prev[data-id="' + sectionId + '"]');
    var nextBtn = document.querySelector('.bsl-arr--next[data-id="' + sectionId + '"]');

    function getScrollAmount() {
      var card = track.querySelector('.bsl-card');
      var gap = parseInt(getComputedStyle(track).gap) || 16;
      return card ? card.offsetWidth + gap : 316;
    }

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  }

  document.querySelectorAll('.bsl-wrap').forEach(function (el) {
    var id = el.id.replace('bsl-', '');
    initSlider(id);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) initSlider(id);
  });
})();